export default values => ({
  ...values,
  isDoctorWithTitle: values.isDoctorWithTitle || false,
  yearsOperating: values.yearsOperating || '',
  tikTok: values.tikTok || '',
  instagram: values.instagram || '',
  facebook: values.facebook || '',
  monthlyIncome: values.monthlyIncome || ''
});
